import styled from "styled-components";
import Control from "../components/molecules/Control";
import {Link} from "react-router-dom";

const Inner = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 65rem;
  min-height: 100vh;
  padding: 2rem;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  color: var(--white);
  background-color: var(--color-1);
  text-align: center;

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
  
  .cta {
    position: absolute;
    top: 40%;
    left: 20%;
    text-decoration: none;
    color: var(--color-1);
    background-color: var(--color-6);
    padding: 1rem 2rem;
    border-radius: 0.5rem;
    font-weight: bold;
    ${(props) => props.theme.fluidType(1)};
    transform: rotate(-10deg);
    transition: transform 0.2s ease-in-out;
    &:hover {
      background-color: var(--color-7);
      transform: rotate(10deg);
    }
  }
`;

const ComponentHolder = styled.div`
  width: 100%;
  max-width: 15rem;
  padding: 2rem;
  @media (${(props) => props.theme.breakpoints.sm}) {
    max-width: 30rem;
  }
  margin-top: auto;

  .inner {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
  }

  .innerinner {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  svg {
    path,
    ellipse,
    circle,
    rect,
    polygon {
      fill: var(--white) !important;
    }
  }
`;

const Index = () => {
  return (
    <Inner>
      <ComponentHolder>
        <div className="inner">
          <div className="innerinner">
            <Control />
          </div>
        </div>
      </ComponentHolder>

      <Link className="cta" to="/fvs-tool">Try the tool!</Link>

      <h1>Flexible Visual Systems Design Tool</h1>
      <p className="intro-paragraph">
        This tool is a working design for developing and using FVS based
        designs.
      </p>
      <p>
        <b>
          Based on{" "}
          <a
            href="https://flexiblevisualsystems.info/"
            target="_blank"
            rel="noopener noreferrer"
          >
            the work of Dr. Martin Lorenz.
          </a>
        </b>
        <br />
        <em>
          Built & designed by{" "}
          <a
            href="https://supermarket.london"
            target="_blank"
            rel="noopener noreferrer"
          >
            Supermarket
          </a>{" "}
          &{" "}
          <a
            href="https://publicwebsites.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Public
          </a>
          .
        </em>
      </p>
    </Inner>
  );
};

export default Index;
